import React from 'react';
import './NotificationsAsset.scss';
import { useTranslation } from 'react-i18next';
import NotificationsAssetCategory from './NotificationsAssetCategory/NotificationsAssetCategory';
import NotificationsAssetSelect from './NotificationsAssetSelect/NotificationsAssetSelect';

const NotificationsAsset: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="notifications-manager-asset">
      <h3 className="notifications-manager-title">
        {t('components:notifications_manager.select_asset')}
      </h3>
      <NotificationsAssetSelect />
      <NotificationsAssetCategory />
    </div>
  );
};

export default NotificationsAsset;
